import ImageAbout1 from '../asserts/about/about1.png'
import ImageAbout2 from '../asserts/about/about2.png'
import ImageAbout3 from '../asserts/about/about3.png'
import ImageAboutTitleBackground from '../asserts/about/title-background.png'
import ImageAboutTab1Image1 from '../asserts/about/tab1-image1.png'
import ImageAboutTab1Image2 from '../asserts/about/tab1-image2.png'
import ImageAboutTab1Image3 from '../asserts/about/tab1-image3.png'
import ImageAboutTab1Image4 from '../asserts/about/tab1-image4.png'
import ImageAboutTab2Image1 from '../asserts/about/tab2-image1.png'
import ImageAboutTab2Image2 from '../asserts/about/tab2-image2.png'
import ImageAboutTab2Image3 from '../asserts/about/tab2-image3.png'
import ImageAboutTab2Image4 from '../asserts/about/tab2-image4.png'
import ImageAboutTab2Image5 from '../asserts/about/tab2-image5.png'
import ImageAboutTab3Image1 from '../asserts/about/tab3-image1.png'
import ImageAboutTab3Image2 from '../asserts/about/tab3-image2.png'
import ImageAboutTab3Image3 from '../asserts/about/tab3-image3.png'
import ImageAboutTab4Image1 from '../asserts/about/tab4-image1.png'
import ImageAboutTab4Image2 from '../asserts/about/tab4-image2.png'
import ImageAboutTab4Image3 from '../asserts/about/tab4-image3.png'

const ABOUTCONFIG = {
  title: { en: 'About Us', cn: '关于我们', background: ImageAboutTitleBackground },
  introduction: {
    en: 'Jumin Bio-technologies Co.,Ltd is a manufacturing basis of single-use sterile medical device and medical wrapper, It is situated in Shanghai Fengpu Jianghai economic area, which was invested by China Double-Dove group with more than 1500 million RMB，which occupies an area of 250 acres. ',
    cn: '聚民生物科技有限公司是专业研发和制造一次性使用无菌医疗器械和药品包装材料的生产基地，由双鸽集团在上海奉浦江海经济园区投资1.5亿多元建造的，公司占地250亩。'
  },
  info: [
    {
      title: { en: 'Corporate Overview', cn: '公司概括' },
      image: ImageAbout1,
      content: [
        {
          type: 'paragraph',
          en: 'Jumin Bio-technologies Co.,Ltd is a manufacturing basis of single-use sterile medical device and medical wrapper, It is situated in Shanghai Fengpu Jianghai economic area, which was invested by China Double-Dove group with more than 1500 million RMB，which occupies an area of 250 acres. The company has been established for more than 20 years and has served more than 10000 customers. Jumin Bio-technologies Co.,Ltd produces a variety of single-use sterile syringes of one billion each year and non-PVC co-extrusion film 20 million squares, ranking of single-use sterile medical equipment manufactures in China scale the front.',
          cn: '聚民生物科技有限公司是专业研发和制造一次性使用无菌医疗器械和药品包装材料的生产基地，由双鸽集团在上海奉浦江海经济园区投资1.5亿多元建造的，公司占地250亩。距今20年的发展历程，曾服务10000余家客户。生产产能各种规格的一次性使用无菌注射器每年10亿支产能，非PVC共挤膜2千万平方米，位居中国一次性无菌医疗器械生产企业规模前列。'
        },
        { type: 'image', src: ImageAboutTab1Image1 },
        {
          type: 'paragraph',
          en: '2015 February Jumin Bio-Technologies Co.,Ltd incorporation Zhejiang Chimin Pharmaceutical CO.,LTD on the Shanghai stock exchange.2016 The company has set up branch in Spain. Chimin Pharmaceutical is basing on the international field of vision, set up the branch in Spain, and in cooperation on projects with companies in more than ten countries and regions, including the USA、Australia、Korea、Japan and Taiwan. Double-Dove brand products are exported to the USA 、Australia、Argentina、Brazil、Chile, and other countries. It has been widely praised by customers.',
          cn: '2015年2月聚民生物科技有限公司并入浙江济民制药股份有限公司在上海证券交易所上市。济民制药立足国际化视野，在2016年欧洲西班牙设立分公司，产品始终以优异的质量及一流的品牌形象畅销国内，并远销美国，俄罗斯、欧盟和巴西、智力、委内瑞拉等南美国家，深受广大消费者的好评。'
        },
        { type: 'image', src: ImageAboutTab1Image2 },
        {
          type: 'paragraph',
          en: 'Jumin Bio-Technologies Co.,Ltd sticks to the concept that ‘Quality is the life to the enterprise ’and it has established a set of scientific and efficient quality guarantee system. Shanghai Double-Dove takes the lead to become ISO13485 and CE compliant in the industry.Jumin Bio-technologies Co.,Ltd remains true to our original aspiration and markets progress through time and new technology, at the same time , the company accesses to advanced management and technology for increasing competitiveness. The involvement also provides valuable training to many of our employees , that will promote product technology upgrading and enhance the core competitiveness,  we are creating a first-class medical equipment production enterprise!',
          cn: '聚民生物科技有限公司牢固树立“质量就是生命”的观念，建立了一整套科学有效的质量保证体系。在国内同行业中通过ISO13485，CE质量认证。聚民生物不忘初心，与时俱进，融会贯通，引进国际化的管理技术，提高科研研发和创新能力，汇聚和培养优秀人才，促进产品技术升级换代，增强核心竞争力，全力打造一流的医疗器械生产企业！'
        },
        {
          type: 'subtitle',
          en: 'Graphic materials',
          cn: '西班牙分公司'
        },
        {
          type: 'paragraph',
          en: 'LINEAR is part of CHIMIN group since July 2016 when CHIMIN acquired 100% of the company shares.',
          cn: 'LINEAR于2016年7月并入济民，成为济民的全资子公司。'
        },
        {
          type: 'paragraph',
          en: 'Founded in 1994 and located in Barcelona area, LINEAR is a biotechnology company dedicated in developing, manufacturing, and marketing In Vitro Diagnostics products, instruments and reagents, covering different diagnostic markets: Biochemistry, Immunology, Microbiology, Hematology and Molecular Biology.',
          cn: 'LINEAR成立于1994年，位于巴塞罗那地区，是一家致力于开发、制造和销售体外诊断产品、仪器和试剂的生物技术公司，覆盖不同的诊断市场：生物化学、免疫学、微生物学、血液学和分子生物学。'
        },
        { type: 'image', src: ImageAboutTab1Image3 },
        {
          type: 'paragraph',
          en: 'During more than 25 years of activity, LINEAR has been able to develop a worldwide distribution network what has introduced the products of the company in more than 125 countries. Our experience in Healthcare plus our high number of international contacts have been essential during this COVID-19 pandemic because LINEAR has introduced a wide range of products used for diagnosing COVID-19 disease and for preventing the infections as well: PCR test, Ag (Antigen) test, extraction and sampling kits, ELISA reagents and surgical face masks.',
          cn: '在超过25年的经营活动中，LINEAR已经开辟出一个全球分销网络，产品远销125个国家。我们在医疗保健方面的丰富经验，在这次COVID-19大流行期间，LINEAR已经推出了一系列用于诊断COVID-19疾病和预防感染的产品：PCR检测、Ag（抗原）检测、提取和取样试剂盒，ELISA试剂和外科口罩。'
        },
        { type: 'image', src: ImageAboutTab1Image4 },
        {
          type: 'paragraph',
          en: 'In addition, LINEAR is actively investing in R&D for developing and improving our products with a clear objective: to become a company leader in Healthcare offering high quality In Vitro Diagnostic products at competitive prices.',
          cn: '此外，LINEAR正积极投资研发，开发和改进我们的产品，目标定位：成为医疗保健领域的领导者，以具有竞争力的价格提供高质量的体外诊断产品。'
        }
      ]
    },
    {
      title: { en: 'Corporate Culture', cn: '企业风采' },
      image: ImageAbout1,
      content: [
        { type: 'image', src: ImageAboutTab2Image1 },
        {
          type: 'paragraph',
          en: 'Jumin Bio-technologies Co.,Ltd adheres to the people-oriented approach and attaches importance to introduction of talents, in addition, we also respects and cares for employees ,we provides them with a good living and working environment , that can give full play to the enthusiasm and creativity of all employees. Enterprise gratitude for the source of benefit and actively participate in social activities for public good, which offers the most sincere love for human health.',
          cn: '聚民生物坚持以人为本，重视人才的引进及培养，尊重和关爱职工，为职工提供良好的生活及工作环境，充分发挥全体职工的积极性和创造性。企业饮水思源，积极参与社会公益活动，奉献社会，为人类健康，献至诚至爱。'
        },
        {
          type: 'subtitle',
          en: 'Cherish Talents And Human Life',
          cn: '以人为本 生命至上'
        },
        { type: 'image', src: ImageAboutTab2Image2 },
        {
          type: 'subtitle',
          en: 'Reflect Corporate Value',
          cn: '心系社会 体现企业价值'
        },
        { type: 'image', src: ImageAboutTab2Image3 },
        {
          type: 'subtitle',
          en: 'Fulfill Corporate Responsibility',
          cn: '心系民生 践行企业责任'
        },
        { type: 'image', src: ImageAboutTab2Image4 },
        {
          type: 'subtitle',
          en: 'Corporate Success',
          cn: '公司荣誉'
        },
        { type: 'image', src: ImageAboutTab2Image5 },
        {
          type: 'paragraph',
          en: 'Successes only stand for the past, while wo believe that the future achievements is more important With rational thinking we face new challenges seriously and persistently. We believe that we can always do better by exploiting innovation and repaying to the society.',
          cn: '荣誉只能代表过去，双鸽人更看重的是未来，保持理性的心态，始终严谨、理智、执着地面对新的挑战，不断地开拓创新，创造佳绩，回报社会。'
        }
      ]
    },
    {
      title: { en: 'Scientific Research Capacity', cn: '科研力量' },
      image: ImageAbout2,
      content: [
        { type: 'image', src: ImageAboutTab3Image1 },
        { type: 'image', src: ImageAboutTab3Image2 },
        { type: 'image', src: ImageAboutTab3Image3 },
        {
          type: 'paragraph',
          en: 'The Double Dove Group employs a professional scientific research team for years, the company has been cooperating with many universities and scientific research institutions, which provide the group with a strong Research & Development capacity.SCIENTIFIC RESEARCH AND QUALITY CONTROLThe Double-Dove Group has implemented a series of scientific and effective production quality control systems. By strictly following the international specialized standards, product specifications meet the requirements of ISO13485 protocol and processes. Special attention is paid to managing part/assembly quality by utilizing the in-house testing laboratory ,complete with all necessary analysis instruments for performing the required quality inspections. These include: particulate balance counters, UV spectrophotometers, high performance liquid chromatography units, and much more. The quality checking system works on a “Zero Defect Program”. Prior to Double-Dove producing any part, all raw materials are checked to insure proper specifications for each specific product（no unacceptable raw material is ever used）.Additionally, no quality control rejected final assembly will ever be sold by Double-Dove in the marketplace.',
          cn: '公司拥有专业的科研队伍，与国内多所高等学校及科研机构建立长期稳定的技术开发合作关系，研发实力雄厚。科研与质量控制：公司建立了一套科学有效的药品和医疗器械质量保证体系。严格按照ISO13485体系要求组织生产。注意质量检验，配有微粒检测仪、紫外分光仪、液相色谱仪、原子吸收光谱仪等国内外先进的检测仪器。坚持质量一票否决制，严把原料采购关、生产过程控制关和最终产品放行关，保证不合格原料不投入，不合格半成品不转序，不合格产品不出厂。'
        }
      ]
    },
    {
      title: { en: 'Professional Production Equipment', cn: '专业设备' },
      image: ImageAbout3,
      content: [
        { type: 'image', src: ImageAboutTab4Image1 },
        { type: 'image', src: ImageAboutTab4Image2 },
        { type: 'image', src: ImageAboutTab4Image3 },
        {
          type: 'paragraph',
          en: 'Jumin Bio-technologies Co., Ltd promotes technological innovation ,improves the technical content of products and invests to improve purification system and the industrial automatic system, which takes the lead in China to automatically pour, print, assemble, pack and sterilize with computer, it improves labor productivity and health condition. Addition, the company is the first to use the technology of paper-compound color packs, which reduces EO remnant, enhances product quality and effectively prevent counterfeiting problem.',
          cn: '聚民生物科技有限公司推进科技技术创新，提高产品技术含量并投产改造净化系统和工业化系统，在国内领先实现自动化注塑、印刷、装配、包装和电脑化灭菌，大大提高生产率及卫生条件，并首家使用注射器、输液器纸塑复合彩色包装技术，减少环氧乙烷气体残留量，即提高产品品质，又避免了产品假冒。'
        }
      ]
    }
  ]
}

export default ABOUTCONFIG